import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
import type { Tomo } from '../data/packContents';
export const VolumeCard = ({
  tomo
}: {
  tomo: Tomo;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = `volume-${tomo.n}-content`;
  return <article className="glass-panel rounded-sm p-4 md:p-5" data-id="element-276" data-mp="y4gr5hn26ljh">
      <div className="flex items-start gap-4" data-id="element-277" data-mp="1ut4vxc9rkcay">
        <img src={tomo.cover} alt={`Volume ${tomo.n}: ${tomo.title}`} loading="lazy" className="w-14 md:w-16 shrink-0 aspect-[4/5] object-cover border border-brand-gold/40" data-id="element-278" data-mp="1uswh3eu2ywx4" />

        <div className="min-w-0 flex-1" data-id="element-279" data-mp="1l2thuwwd8mqc">
          <span className="block font-seal text-[9px] uppercase tracking-seal text-brand-goldDark mb-1" data-id="element-280" data-mp="1l1iayo7miyv0">
            Volume {tomo.n}
          </span>
          <h3 className="font-display font-bold text-base md:text-lg leading-tight text-brand-burgundy" data-id="element-281" data-mp="2dk5qzp7rjnp8">
            {tomo.title}
          </h3>
          <p className="mt-1 text-[13px] leading-snug text-brand-muted" data-id="element-282" data-mp="28rw30eq7kxpl">
            {tomo.subtitle}
          </p>
        </div>

        <button type="button" aria-expanded={isOpen} aria-controls={panelId} aria-label={isOpen ? `Nascondi il contenuto del Volume ${tomo.n}` : `Mostra il contenuto del Volume ${tomo.n}`} onClick={() => setIsOpen(v => !v)} className="shrink-0 mt-0.5 p-1.5 border border-brand-gold/40 rounded-sm text-brand-goldDark hover:bg-brand-surfaceLight/50 transition-colors duration-150 focus:outline-none focus-visible:ring-1 focus-visible:ring-brand-gold" data-id="element-283" data-mp="3cb3pi9k8kdz9">
          <Plus className={`w-4 h-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-284" data-mp="2tm6xkccb9xk7" />
        </button>
      </div>

      <AnimatePresence initial={false} data-id="element-285" data-mp="2jmg1i683rai0">
        {isOpen && <motion.div id={panelId} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-286" data-mp="2jn7nqqft7vvm">
            <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1.5 text-[13px] text-brand-text/85" data-id="element-287" data-mp="gf7bcf679s44">
              {tomo.features.map(f => <li key={f} className="flex items-start gap-2" data-id="element-288" data-mp="6fgcy2eiqsyr">
                  <span aria-hidden="true" className="mt-1.5 w-1 h-1 rotate-45 bg-brand-gold shrink-0" data-id="element-289" data-mp="6hsuiegd71ba" />
                  <span data-id="element-290" data-mp="2g7j6xjhav37">{f}</span>
                </li>)}
            </ul>
          </motion.div>}
      </AnimatePresence>
    </article>;
};